<template>
  <md-card-content>
    <!-- 登記情報提供サービス-->
    <div class="md-layout md-gutter">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
        <label>登記情報提供サービスID</label>
      </div>
      <div class="md-layout-item">
        <div class="md-layout md-alignment-center-space-between">
          <md-field class="md-layout-item" :class="getActivationValidationClass()">
            <label>登記情報提供サービスID</label>
            <md-input :disabled="sending" required v-model="form.t_service_id"/>
            <span class="md-helper-text">※法人利用の登記情報提供サービスの利用者IDをご利用ください。管理者ID、一時利用ID、個人利用IDはご利用いただけません。</span>
            <span class="md-error" v-if="getValidationResponseMessage('t_service_id')">
              {{ getValidationResponseMessage('t_service_id') }}
            </span>
            <span class="md-error" v-else-if="!$v.form.t_service_id.required">
              {{ errors.t_service_id.required }}
            </span>
            <span class="md-error" v-else-if="!$v.form.activated.mustBeTrue">
              {{ errors.unactivatedMessage }}
            </span>
          </md-field>
          <md-icon class="md-checked" v-if="form.activated">check_box</md-icon>
          <md-icon v-else>check_box_outline_blank</md-icon>
          <md-button :disabled="sending || form.activated || !form.t_service_id"
                     class="md-raised md-primary md-layout-item md-size-25"
                     @click="openDialog">
            <span>パスワード入力</span>
          </md-button>
        </div>
      </div>
    </div>
    <activation-modal :md-active.sync="showDialog" v-bind:t_service_id="form.t_service_id"
                      @close="closeActivationModal" @activationSuccess="activationSuccess"></activation-modal>
  </md-card-content>
</template>

<script>
import CommonMixin                                    from "../../mixins/commonMixin";
import Validation                                     from "../../modules/validation";
import Common                                         from "../../modules/common";
import ActivationModal                                from "../ActivationModal";
import {validationMixin}                              from "vuelidate";
import ContractFormMixin                              from "../../mixins/contractFormMixin";
import {apiClientWithUserToken as apiClient, apiList} from "../../modules/apiClient";

export default {
  name      : 'ContractFormTService',
  components: {ActivationModal},
  mixins    : [CommonMixin, validationMixin, ContractFormMixin],
  props     : ['value'],
  data      : () => ({
    validated    : null,
    showDialog   : false,
    oldTServiceId: null,
    form         : {
      t_service_id: null,
      activated   : false,
    },
    errors       : {
      t_service_id      : {
        required: Validation.errorMessage(Validation.rules.required, 'tServiceID'),
      },
      unactivatedMessage: Common.messages.activation.unactivated,
    },
  }),
  validations() {
    return {
      form: {
        t_service_id: {
          required: true,
        },
        activated   : {
          mustBeTrue: Validation.mustBeTrue,
        },
      }
    }
  },
  methods: {
    validate() {
      this.$v.$touch();
      this.validated = !this.$v.$invalid;
    },
    openDialog() {
      this.$v.form.t_service_id.$touch();
      if (this.$v.form.t_service_id.$invalid) {
        return;
      }
      this.showDialog = true;
    },
    closeActivationModal() {
      this.showDialog = false;
    },
    activationSuccess() {
      this.showDialog     = false;
      this.duplicateDetection();
    },
    duplicateDetection() {
      apiClient
          .get(apiList.accounts.duplicateDetection, {
            params: {t_service_id: this.form.t_service_id}
          })
          .then(response => {
            if (this.hasResponseErrors(response)) {
              this.form.activated = null;
              return;
            }
            this.oldTServiceId  = this.form.t_service_id;
            this.form.activated = true;
          })
          .catch(error => {
            this.errorMessages  = [error.message];
            this.form.activated = null;
          });
    },
    getActivationValidationClass() {
      const tServiceValidation = this.getValidationClass('t_service_id');
      if (tServiceValidation["md-invalid"]) {
        return tServiceValidation;
      }
      return this.getValidationClass('activated');
    },
    getStateError() {
      if (this.stateValidateResponse) {
        setTimeout(() => {
          this.validateResponse = this.stateValidateResponse ?? [];
          const validationClass = this.getActivationValidationClass();
          if (validationClass['md-invalid']) {
            this.form.activated = false;
            this.oldTServiceId  = null;
          }
        }, this.getStateTimeout)
      }
    },
  },
  watch  : {
    value              : {
      deep: true,
      handler() {
        this.form = this.value;
        if (this.form.activated && !this.oldTServiceId) {
          this.oldTServiceId = this.form.t_service_id;
        }
      }
    },
    "form.t_service_id": function () {
      this.form.activated = this.oldTServiceId && this.form.t_service_id === this.oldTServiceId;
      this.$emit('input', this.form);
    },
    "form.activated"   : function () {
      this.$emit('input', this.form);
    },
  },
}
</script>

<style lang="scss" scoped>
.md-checked {
  color: #44D644 !important;
}
</style>
